import { useCartStore } from "@/stores/cart";
import { useCheckoutStore } from "@/stores/checkoutStore";

export function setNonRequiredFields(){
    const checkoutStore = useCheckoutStore();
    const cartStore = useCartStore();
    if(checkoutStore.startPurchaseData) {
    if(!checkoutStore.startPurchaseData.require_email) {
      cartStore.currentOrderData.email = '-';
      cartStore.currentOrderData.email2 = '-';
    }
    if(!checkoutStore.startPurchaseData.require_name) {
      cartStore.currentOrderData.name = '-';
    }
    if(!checkoutStore.startPurchaseData.require_address) {
      cartStore.currentOrderData.address = '-';
    }
    if(!checkoutStore.startPurchaseData.require_city_zip) {
      cartStore.currentOrderData.zip = '-';
      cartStore.currentOrderData.city = '-';
    }
    if(!checkoutStore.startPurchaseData.require_phone) {
      cartStore.currentOrderData.telephone = '-';
    }
    if(!checkoutStore.startPurchaseData.require_country) {
      cartStore.currentOrderData.country = '-';
    }
  }
}